const sizingProps: PropertyKey[] = [
  'width',
  'maxWidth',
  'minWidth',
  'height',
  'maxHeight',
  'minHeight',
  'sizeWidth',
  'sizeHeight',
  'boxSizing',
];

export const isSizingProp = (prop: PropertyKey) => sizingProps.includes(prop);
export const isNotSizingProp = (prop: PropertyKey) =>
  !sizingProps.includes(prop);
